
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chargeback",
      function () {
        return require("private-next-pages/chargeback.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chargeback"])
      });
    }
  